import { Component, input } from '@angular/core';

import { NumberPipe } from '@app/@core/common/pipes';

@Component({
  selector: 'currency-input',
  templateUrl: './currency-input.component.html',
  imports: [NumberPipe]
})
export class CurrencyInputComponent {
  public value = input<number | null | string>(0);
  public iconClass = input('');
  public valueClass = input('');
  public mainClass = input('');
  public convertDigits = input('');
}
